import React, { useEffect } from "react";
import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  isPlatform,
} from "@ionic/react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { findUser } from "../../store/userShow/actions/find-user";
import { findUserMessages } from "../../store/userShow/actions/find-user-messages";
import { findUserRoles } from "../../store/userShow/actions/findUserRoles";
import { HeaderSection } from "./components/HeaderSection";
import { findDocuments } from "../../store/userShow/actions/findDocuments";
import { SegmentsSection } from "./components/SegmentsSection";
import { LoadingSection } from "./components/LoadingSection";
import { findUserDocuments } from "../../store/userShow/actions/findUserDocuments"

export const SupervisorUserShow: React.FC = () => {
  const dispatch = useDispatch();
  const { id }: { id: string } = useParams();

  useEffect(() => {
    const findData = async () => {
      await dispatch(findUser(Number(id)));
      dispatch(findUserMessages(Number(id)));
      dispatch(findUserRoles(Number(id)));
      dispatch(findUserDocuments(Number(id)));
      dispatch(findDocuments());
    };

    findData();
  }, [dispatch, id]);

  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton
              text={isPlatform("ios") ? "Supervisión" : ""}
              defaultHref="/app/supervision"
              color="light"
            />
          </IonButtons>
          <IonTitle>Colaborador</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense" class="ion-no-border">
          <IonToolbar>
            <IonTitle size="large">Colaborador</IonTitle>
          </IonToolbar>
        </IonHeader>

        <LoadingSection />
        <HeaderSection />

        <SegmentsSection userId={id} />
      </IonContent>
    </IonPage>
  );
};
